import * as React from "react";

export const NavCollapse = (props) => (
    <svg style={props.style  || {}} width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.2" d="M5.8 20L5.8 1.00077L1.8 1C1.58783 0.999996 1.38435 1.0834 1.23432 1.23186C1.08429 1.38032 1 1.58167 1 1.79163L1 19.2076C1 19.4176 1.08429 19.6189 1.23432 19.7674C1.38435 19.9158 1.58783 19.9992 1.8 19.9992L5.8 20Z" fill={props.active ? "#061C3D" : "#969BA5"} />
        <path d="M1 1.79167L1 19.2083C1 19.6456 1.35817 20 1.8 20H16.2C16.6418 20 17 19.6456 17 19.2083V1.79167C17 1.35444 16.6418 1 16.2 1H1.8C1.35817 1 1 1.35444 1 1.79167Z" stroke={props.active ? "#061C3D" : "#969BA5"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M5.80005 20L5.80005 1" stroke={props.active ? "#061C3D" : "#969BA5"} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

);
